import Logo from './misc/Logo'
import { useEffect } from 'react'
import { Alert, version } from '.'
import { store } from './stores/Store'
import { observer } from 'mobx-react-lite'
import Header from './components/layout/Header'
import ErrorBoundary from './misc/ErrorBoundary'
import { Button, LinearProgress } from '@mui/material'
import MainView from './components/views/main/MainView'
import ViewBanner from './components/layout/ViewBanner'
import BreadCrumb from './components/views/main/BreadCrumb'
import UiDemoView from './components/views/ui_demo/UiDemoView'
import { Link, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import SetNewPassword from './components/form/authentication/PasswordSetForm'
import AuthenticationForms from './components/form/authentication/AuthenticationForms'


export default observer(function App() {
	return (
		<div className="App">
			<ErrorBoundary>
				<Routes>
					<Route path="" element={<FormRoutes />}>
						<Route path="" element={<AuthenticationForms />} />
						<Route path="*" element={<NotFound />} />
						<Route path="message" element={<Message />} />
					</Route>

					<Route path="app" element={<AuthenticatedRoutes />}>
						<Route path="" element={<Navigate replace to="/app/main" />} />
						<Route path="*" element={<Navigate replace to="/app/main" />} />
						
						<Route path="form" element={<FormRoutes />}>
							<Route path="" element={<Navigate replace to="/app/main" />} />
							<Route path="*" element={<Navigate replace to="/app/main" />} />
							<Route path="password-set" element={<SetNewPassword />} />
						</Route>

						<Route path="main" element={<MainRoutes />}>
							<Route path="" element={<MainView />} />
							<Route path=":folder_uid" element={<MainView />} />
							<Route path=":folder_uid/:leafnode_uid" element={<MainView />} />
							<Route path="ui-demo" element={<UiDemoView />} />
						</Route>
					</Route>
				</Routes>
			</ErrorBoundary>
		</div>
	)
})


const AuthenticatedRoutes = observer(function () {

	useEffect(() => {
		
		var message = store.AppStore.getURLPeram(window.location.href, "message")
		if (message) {
			Alert({message: decodeURI(message)})
		}

		store.AppStore.loginOauth().catch(() => {
			Alert({message: "Failed to login with OAuth"})
		})
		
		var originalRequestUrl = window.location.href
		store.AppStore.init().catch(() => {
			Alert({message: "Failed to load session"})
			
			if (originalRequestUrl.includes("/app/main/")) {
				console.log("Setting redirect_after_login:", originalRequestUrl)
				localStorage.setItem("redirect_after_login", originalRequestUrl)
			}

			store.AppStore.resetApp()
		})

	}, [store.AppStore])

    if (!store.AppStore.appLoaded) {
		return <AppLoading />
	}

    return <Outlet />
})


const FormRoutes = observer(function () {

	store.AppStore.setPageTitle("AORA")
	var subdomain = window.location.hostname.split(".")[0]

	return (
		<div className="view-guest">
			<div className="card" style={{margin: "0 auto"}}>
				<Outlet />
			</div>

			<div className="view-guest-footer">
				<Logo type="block" width="120px" color="white" />
				<small>{subdomain} {version}</small>
			</div>
			
			<div style={{zIndex: -10}} id="animation"></div>
		</div>
	)
})


const MainRoutes = observer(function () {
	return (
		<>
			<Header />
        	<ViewBanner title={<BreadCrumb />} />
			<Outlet />
		</>
	)
})


function NotFound () {
    return (
        <div style={{minWidth: "320px", display: "grid", gap: "5px"}}>
            <h2>Page not found</h2>

            <p>We couldn't find the page you're looking for.</p>
            
            <Link to="/app/main">
                <Button color="success" variant="contained" className="btn btn-md">
                    Return to App
                </Button>
            </Link>
        </div>
    )
}


function Message () {

	var title = store.AppStore.getURLPeram(window.location.href, "title")
	var body = store.AppStore.getURLPeram(window.location.href, "body")

    return (
		<div style={{minWidth: "360px", maxWidth: "80vw"}}>
			<h2>{title}</h2>

			<p>{body}</p>
			
			<small style={{margin: "auto", color: "#314A94", textDecoration: "underline"}}>
				<Link to="/">
					Go back to Login page
				</Link>
			</small>
		</div>
    )
}


function AppLoading () {
	return (
		<div>
			<LinearProgress />
			
			{store.AppStore.token ? (
				<div style={{display: "flex", gap: "6px", justifyContent: "center", alignItems: "baseline", padding: "30px 15px"}}>
					<Logo height="12px" />
					<h4 style={{color: "#313131"}}>is loading your session, please wait...</h4>
				</div>
			) : null}
		</div>
	)
}